import React from 'react'

export default function DangoTFT() {
    return (
        <section className="small-section">
            <h2>Dango Pattern</h2>
            <img className="pattern-assembly-image" src="/images/patterns/dango/dango-thumbnail.jpg" alt="dango"></img>
            <h3>Yarn needed:</h3>
            <p>
                <ul>
                    <li>White</li>
                    <li>Orange</li>
                    <li>Yellow</li>
                </ul>
                (this pattern makes the basic dango, but there can be changes made in color to make other variations) <br></br>
                Please don't hesitate to reach out if you have any questions about the pattern or need help with it! <br />
                My email is dangoploof@gmail.com <br />
            </p>
            <h3>Abbreviations: </h3>
            <p>
                <ul>
                    <li>sc = single crochet</li>
                    <li>dc = double crochet</li>
                    <li>trc = treble crochet</li>
                    <li>mr = magic ring</li>
                    <li>inc = increase</li>
                    <li>dec = decrease</li>
                </ul>

            </p>

            <h3>Head & Body</h3>
            <p>
                Start with white <br />
                Round 1: 6 sc mr (6) <br />
                Round 2: 6 inc (12) <br />
                Round 3: (1 sc, 1 inc)* repeat around (18) <br />
                Round 4: (2 sc, 1 inc)* repeat around (24) <br />
                Round 5: (3 sc, 1 inc)* repeat around (30) <br />
                Round 6: (4 sc, 1 inc)* repeat around (36) <br />
                Round 7: (5 sc, 1 inc)* repeat around (42) <br />
                Round 8-14: 1 sc around (48) [7 rounds] <br />
                Round 15: (5 sc, 1 dec)* repeat around (36) <br />
                Round 16: (4 sc, 1 dec)* repeat around (30) <br />
                Round 17: (3 sc, 1 dec)* repeat around (24) <br />
                Start stuffing the body <br />
                Round 18: (2 sc, 1 dec)* repeat around (18) <br />
                Round 19: (1 sc, 1 dec)* repeat around (12) <br />
                Round 20: 1 dec around (6) <br />
            </p>

            <h3>Ears (2x)</h3>
            <p>
                Start with Orange <br />
                Round 1: 6 sc mr (6) <br />
                Round 2: 6 sc (6) <br />
                Switch to White <br />
                Round 3: (1 sc, 1 inc)* repeat around (9) <br />
                Round 4: (2 sc, 1 inc)* repeat around (12) <br />
                Round 5: (3 sc, 1 inc)* repeat around (15) <br />
                Fasten off, leave tail for sewing <br />
                Do not stuff the ears
            </p>

            <h3>Tail</h3>
            <p>
                Start with white <br />
                Round 1: 6 sc mr (6) <br />
                Round 2-14: 6 sc (6) [13 rounds] <br />
                Fasten off, leave tail for sewing <br />
                Stuff the tail very lightly
            </p>

            <h3>Tail Star (2x)</h3>
            <p>
                Start with Yellow <br />
                Round 1: 5 sc mr (5) <br />
                Round 2: 5 inc (10) <br />
                Round 3: (slst in 1 sc, [hdc, dc, trc, dc, hdc] in the next sc)* 5 (30) <br />
                Fasten off, leave tail for sewing on one of the stars
            </p>

            <h3>Back Star</h3>
            <p>
                Start with Orange <br />
                Round 1: 4 sc mr (4) <br />
                Round 2: 4 inc (8) <br />
                Round 3: (slst in 1 sc, [dc, trc, dc] in the next sc)* 4 (16) <br />
                Fasten off, leave tail for sewing on one of the stars
            </p>


            <h3>Assembly</h3>
            <p>
                1. Sew the yellow stars together, stuff lightly <br />
                2. Sew the yellow star on the tail <br />
                3. Sew the tail onto the body <br />
                4. Sew the ears onto the head (I sew them between rounds 3 and 8) <br />
                5. Sew side body designs (between rounds 11 and 12, and 13 and 14 about 5 stitches long)<br />
                <img className="pattern-assembly-image" src="/images/patterns/dango/side_stripes.jpg" alt="orange stripes on the side" /> <br />
                6. Sew the orange star on the back <br />
                <img className="pattern-assembly-image" src="/images/patterns/dango/back_star.jpg" alt="orange star on the back" /><br />
                7. Cut felt and glue on the eyes <br />
                8. Sew on the mouth in a w shape <br />
                Now you are done! <br />
                <img className="pattern-assembly-image" src="/images/patterns/dango/dango.jpg" alt="dango assembled" />
            </p>

            <p>Congrats on finishing!!! <br>
            </br>
                Tag: @dango.ploof on insta to show me your dango!!</p>
            <div className="patterns">
                <a href="/patterns">Back to Patterns</a>
            </div>
        </section>
    );
}